import React, { Component } from "react";
import {
  caseActionLogsType,
  instructionMapType,
} from "../../utils/interfaceType";
import { progress, progressType } from "./process";
import ProgressCard from "../progressCard";
import styles from "./index.less";

export interface optionsType {
  actionCode: number;
  caseStatus: number;
  caseId: number;
  appealStatus?: number;
  createDate: string;
  instructionMap: instructionMapType;
  operator: string;
  operatorType: number;
  actionCodeName: string;
  actionCodeTalkingSkill?: string;
  actionCodeIcon: string;
  actionCodeRedIcon: string;
  actionSucName?: string;
  actionSuc?: string;
  actionSucTalkingSkill?: string;
  actionSucOperator?: string;
  actionSucIcon?: string;
  actionSucRedIcon?: string;
  operators?: string;
  actionType?: number;
  illegalType?:any;
}

interface Props {
  caseActionLogs: caseActionLogsType[];
  appealStatus: number;
  getAppealDetailData: (
    caseId: string | number,
    templateId: string | number
  ) => void;
  setModalType: () => void;
  setRevokeType: () => void;
}

class PunishmentSubsidiary extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  initProgressData = (
    caseActionLogs: caseActionLogsType[],
    appealStatus: number | undefined
  ) => {
    let options: optionsType[] = [];
    caseActionLogs.forEach((caseAction: caseActionLogsType) => {
      progress.forEach((progressAction: progressType) => {
        if (caseAction.actionCode === progressAction.actionCode) {
          options.push({ ...caseAction, ...progressAction });
        }
      });
    });
    return this.renderProgress(options, appealStatus);
  };

  renderProgress(items: optionsType[], appealStatus: number | undefined) {
    const { getAppealDetailData, setModalType, setRevokeType } = this.props;
    return items.map((options: optionsType, index: number) => {
      if (options.actionCode === 1 || options.actionCode === 8) {
        return (
          <React.Fragment key={index}>
            <ProgressCard
              index={index}
              options={options}
              itemsLength={items.length + 1}
              appealStatus={appealStatus}
              type="suc"
              getDetailData={getAppealDetailData}
              setModalType={setModalType}
              setRevokeType={setRevokeType}
            />
            <ProgressCard
              index={index + 1}
              options={options}
              itemsLength={items.length + 1}
              appealStatus={appealStatus}
              getDetailData={getAppealDetailData}
              setModalType={setModalType}
              setRevokeType={setRevokeType}
            />
          </React.Fragment>
        );
      } else {
        return (
          <ProgressCard
            key={index}
            index={index}
            options={options}
            itemsLength={items.length}
            appealStatus={appealStatus}
            getDetailData={getAppealDetailData}
            setModalType={setModalType}
            setRevokeType={setRevokeType}
          />
        );
      }
    });
  }

  render() {
    const { caseActionLogs, appealStatus } = this.props;
    return (
      <div className={styles.punishmentSubsidiary}>
        {this.initProgressData(caseActionLogs, appealStatus)}
      </div>
    );
  }
}

export default PunishmentSubsidiary;
